import React, {Component, Fragment} from 'react';
import './PackageItem.css';
import {Link} from 'react-router-dom';
import {baseURL} from './../../../config';
class PackageItem extends Component {

  

  render() {
    
    // console.log("pi render");
    const {id, picture, products, skreen} = this.props;
    
    let tooltips = products.map(product => (
      <div 
      key={product.id} 
      className="tooltip" 
      data-id={id} 
      onClick={this.props.openModal}
      style={{top:product.top, left:product.left}}>
        {product.id}
      </div>
    ));
    let shoppingBasket = <div style={{position:'absolute', bottom:0, right:0}} className="shopping-basket">
      <i className="fa fa-shopping-bag bag-icon"></i>
    </div>

    let output = (
      <Link to={`/package/${id}`}>
        <img src={`${baseURL}/images/packages/${picture}`}  data-id={id} onClick={this.props.openModal} />
        {tooltips}
        {shoppingBasket}
      </Link>
    );

    if(skreen == "desktop"){
      output = (
        <Fragment>
          <img src={`${baseURL}/images/packages/${picture}`}  data-id={id} onClick={this.props.openModal} />
          {tooltips}
          {shoppingBasket}
        </Fragment>
      );
    }

    return (
          <div className="package-item">
            {output}  
          </div>
    );
  }
}

export default PackageItem;
